import getScenarioStore from '../selectors/getScenarioStore';
import { mutatorAction } from 'satcheljs';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default mutatorAction(
    'setLatestRenderedQFTraceId',
    (latestRenderedQFTraceId: string, scenarioId: SearchScenarioId): void => {
        getScenarioStore(scenarioId).latestRenderedQFTraceId = latestRenderedQFTraceId;
    }
);
